import { useRef } from 'react';
import { useStore } from '@/store/useStore.ts';
import { cn } from '@/ui/lib/utils.ts';
import { RacerCard } from './RacerCard/RacerCard.tsx';
import { ProgressBar } from './ProgressBar/ProgressBar.tsx';
import { useShakePanel } from './useShakePanel.ts';
import './racerSelection.css';

export const RacerSelection = () => {
    const panelRef = useRef<HTMLDivElement>(null);
    const racers = useStore((state) => state.activeHeroes);
    const selectedRacer = useStore((state) => state.selectedRacer);
    const selectRacer = useStore((state) => state.selectRacer);
    const betPlaced = useStore((state) => state.betPlaced);
    const placingBet = useStore((state) => state.placingBet);
    const racersBetCounts = useStore((state) => state.racersBetCounts);
    const shake = useShakePanel(panelRef);

    return (
        <div className="racer-selection">
            <h4 className="racer-selection__title">
                {betPlaced || placingBet ? 'Waiting for bets...' : 'Choose your racer:'}
            </h4>

            <ProgressBar className="racer-selection__progress-bar" />

            <div
                ref={panelRef}
                className={cn(
                    'racer-selection__panel',
                    (betPlaced || placingBet) && 'racer-selection__panel--hidden',
                    shake && 'racer-selection__panel--shake',
                )}
            >
                {racers.map((racer) => {
                    return (
                        <RacerCard
                            key={racer.name}
                            id={racer.name}
                            betsOn={racersBetCounts[racer.name] ?? 0}
                            multiplier={racer.multiplier}
                            selected={selectedRacer === racer.name}
                            onSelect={selectRacer}
                        />
                    );
                })}
            </div>
        </div>
    );
};
